import { BundleDocumentType } from 'models/organization';

// The per-order printable documents a lab can include in a bundle, in display order.
// NOTE: DELIVERY_NOTE and INVOICE are pre-generated artifacts downloaded from S3 (signed URL),
// unlike the rest which denthub-documents generates on the fly. The generation phase must
// branch on this — see [[project_bundle_pregenerated_s3_docs]].
export const BUNDLE_DOCUMENT_TYPES: BundleDocumentType[] = [
    BundleDocumentType.PATIENT_SPECIFICATION,
    BundleDocumentType.ORDER_SUMMARY,
    BundleDocumentType.ORDER_FORM,
    BundleDocumentType.WORK_SHEET_V2,
    BundleDocumentType.WORK_SHEET_SUBCONTRACTOR,
    BundleDocumentType.PATIENT_LABEL,
    BundleDocumentType.DESTINATION_ADDRESS_LABEL,
    BundleDocumentType.ORDER_RECEIPT,
    BundleDocumentType.DELIVERY_NOTE,
    BundleDocumentType.INVOICE,
    BundleDocumentType.DEVIATION_REPORT,
];

// Reuse the exact same translation keys as the order-details print actions so the
// document names stay identical in both places (no parallel copy to drift).
const BUNDLE_DOCUMENT_TYPE_TRANSLATION_KEYS: Record<BundleDocumentType, string> = {
    [BundleDocumentType.PATIENT_SPECIFICATION]: 'orders:PRINT_PATIENT_SPECIFICATION',
    [BundleDocumentType.ORDER_SUMMARY]: 'orders:PRINT_ORDER_SUMMARY',
    [BundleDocumentType.ORDER_FORM]: 'orders:PRINT_ORDER_FORM',
    [BundleDocumentType.WORK_SHEET_V2]: 'orders:PRINT_WORKSHEET',
    [BundleDocumentType.WORK_SHEET_SUBCONTRACTOR]: 'orders:PRINT_WORKSHEET_SUBCONTRACTOR',
    [BundleDocumentType.PATIENT_LABEL]: 'orders:PRINT_PATIENT_LABEL',
    [BundleDocumentType.DESTINATION_ADDRESS_LABEL]: 'orders:PRINT_DELIVERY_ADDRESS_LABEL',
    [BundleDocumentType.ORDER_RECEIPT]: 'orders:PRINT_ORDER_RECEIPT',
    [BundleDocumentType.DELIVERY_NOTE]: 'orders:PRINT_DELIVERY_NOTE',
    [BundleDocumentType.INVOICE]: 'orders:PRINT_INVOICE',
    [BundleDocumentType.DEVIATION_REPORT]: 'orders:PRINT_DEVIATION_REPORT',
};

export const bundleDocumentTypeTranslationKey = (documentType: BundleDocumentType): string =>
    BUNDLE_DOCUMENT_TYPE_TRANSLATION_KEYS[documentType];
